import {
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    Input,
    OnInit,
    AfterViewInit,
    ViewContainerRef,
    OnDestroy,
    EventEmitter,
    Injector,
} from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { EditorTypes } from "@farris/ui-datagrid-editors";
import { PreviewTextboxComponent } from "../components/editor/textbox.component";
import { PreviewComboListComponent } from "../components/editor/combolist.component";

const PreviewEditorList = [
    { name: EditorTypes.TEXTBOX, value: PreviewTextboxComponent },
    { name: EditorTypes.COMBOLIST, value: PreviewComboListComponent },
];
/**
 * 应用在preview-cell组件上
 * 根据type类型，构造具体的编辑器，传递options，column等信息
 * 
 */
@Directive({
    selector: "[preview-cell-editor]",
})
export class PreviewCellEditorDirective
    implements OnInit, AfterViewInit, OnDestroy {
    @Input() column;
    @Input() group: FormGroup;
    @Input() rowData: any;
    @Input() value: any;
    @Input() height: any;
    @Input() previewIndex = -1;
    formControl: FormControl;
    componentRef: ComponentRef<any>;
    private timer = null;
    // 单元格编辑器创建完成
    cellEditorCreated = new EventEmitter();
    // 单元格编辑器销毁
    cellEditorDestory = new EventEmitter();
    //private previewSer: FPreviewEditorService;
    constructor(
        private injector: Injector,
        private resolver: ComponentFactoryResolver,
        private container: ViewContainerRef
    ) {
        //this.previewSer= this.injector.get(FPreviewEditorService);
    }

    ngOnInit() {
        if (this.column.editor && this.column.editor["type"]) {
            this.createCellEditor();
        }
        if (this.group) {
            this.formControl = this.group.controls[this.column.field] as FormControl;
        }
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        this.componentRef = null;

        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    private getEditorComponent(editorType): any {
        let findItem = PreviewEditorList.find((item) => item.name == editorType);
        return findItem ? findItem["value"] : null;
    }
    private createCellEditor() {
        const editorType = this.column.editor.type;
        if (!this.getEditorComponent(editorType)) {
            console.error(`找不到名称为 ${editorType} 对应的类。`);
            return;
        }
        const factory = this.resolver.resolveComponentFactory(
            this.getEditorComponent(editorType)
        );
        this.componentRef = this.container.createComponent(factory);
        this.componentRef.instance.column = this.column;
        this.componentRef.instance.group = this.group;
        //  this.componentRef.instance.height = this.height;
        this.componentRef.instance.controlId =
            "upload-and-preview_" + this.column.field;
        this.componentRef.instance.rowIndex = this.previewIndex;
        this.componentRef.instance.rowId = this.rowData["id"];
        this.updateControlValue();
        this.componentRef.changeDetectorRef.markForCheck();
        this.componentRef.changeDetectorRef.detectChanges();
    }

    private updateControlValue() {
        if (this.group) {
            this.group["bindingData"] = this.rowData;
            if (this.group.controls[this.column.field]) {
                this.group.controls[this.column.field].setValue(this.value, {
                    emitEvent: true,
                });
            }
        }
    }
    /**
     * 内部未使用
     */
    hideCover() {
        if (
            this.componentRef &&
            this.column.editor &&
            (this.column.editor.type === "combolist" ||
                this.column.editor.type === "combo-lookup")
        ) {
            this.componentRef.instance.hide(!1);
        }
    }
}
